import TableSortLabel from '@mui/material/TableSortLabel';

export { TableSortLabel };
